module.exports = __webpack_public_path__ + "img/point-pr.ac1ed674.png";